/**
 * One clock for the sample estate.
 *
 * The sample used to keep two. `closures.ts`, `drift.ts`, `ledger.ts`,
 * `migration.ts`, `planning.ts`, `programme.ts`, `provenance.ts` and
 * `reliability.ts` place their records relative to the real clock, because a
 * demonstration has to answer "last Tuesday" on the Tuesday somebody asks.
 * `data.ts`, `compliance.ts`, `inspections.ts` and `projects.ts` each declared
 * their own `const TODAY = new Date("2026-09-06T06:00:00Z")`. The two agreed
 * for exactly one week — the week the fixtures were written — and then
 * separated by a day per day.
 *
 * What that separation produced was not a broken demonstration but a subtly
 * wrong one, which is worse:
 *
 * * The friction alert that raised WO-000006 drifted out of the seven-day
 *   window the D-Brief searched for the rule behind a closure, so the GACAR
 *   clause silently vanished from an evidence answer that still showed the
 *   closure, the work order and the photographs. The one exhibit a regulator
 *   would ask for was the one that disappeared.
 * * A lamp end-of-life forecast fixed at nineteen days after 6 September is a
 *   prediction about the past from 26 September onward, still presented as a
 *   forecast.
 *
 * Neither announced itself. Both were found by asking what the sample looks
 * like on a day that is not the day it was written.
 *
 * So: one clock, and it is the real one. Every sample record is placed
 * relative to today, the estate stays internally coherent whenever it is
 * opened, and a fixture cannot quietly decay while its neighbours move on.
 *
 * Fixed to 06:00 UTC rather than the moment of import, so that everything
 * derived from it is stable for the whole of a day and two calls a second
 * apart cannot land on different sides of a boundary.
 */
export const TODAY: Date = (() => {
  const d = new Date();
  d.setUTCHours(6, 0, 0, 0);
  return d;
})();
